import { getClientCode } from "@entrilia/shared/api/clientApiContext";
import { parseJsonObject } from "@entrilia/shared/utilities/objectHelper";

interface AuthState {
  client?: string;
}

// On the B2C OAuth callback URL we land at /oauth/?state=<JSON>&code=...
// The state payload — produced by getAuthURL() in shared/auth/b2c/redirects.ts —
// always carries `client` for IR portal sign-in. Falling back to it here ensures
// the access-check report and telemetry name the right client even when the user
// never made it past the access-check page (so updateClientCode never ran).
const readClientFromOAuthState = (): string | undefined => {
  if (typeof window === "undefined") {
    return undefined;
  }

  const stateRaw = new URLSearchParams(window.location.search).get("state");
  if (!stateRaw) {
    return undefined;
  }

  const parsedState = parseJsonObject<AuthState>(stateRaw);
  if (!parsedState) {
    return undefined;
  }

  const client = parsedState.client;
  return typeof client === "string" && client.length > 0 ? client : undefined;
};

export const resolveClientCode = (): string | undefined => getClientCode() || readClientFromOAuthState();
